import clsx from 'clsx';
import { Cart, Close } from 'react-ionicons';

interface CartHeaderProps {
  onIconClick: () => void;
  isOpen?: boolean;
  title: string;
  totalItems: number;
}

const CartHeader = ({
  onIconClick,
  isOpen = false,
  title,
  totalItems,
}: CartHeaderProps) => {
  return (
    <div className="flex flex-none flex-shrink-0 flex-row items-center justify-between">
      <div
        className={clsx(
          'transition-delay text-2xl font-bold text-content-base-default transition-opacity duration-500',
          isOpen ? 'opacity-100' : 'opacity-0',
        )}
      >
        {title}
      </div>
      <div
        className={clsx(
          'absolute right-6 top-8 cursor-pointer transition-all duration-200',
          isOpen ? 'text-content-base-subdued' : 'text-accent-primary',
          !isOpen && 'translate-x-1',
        )}
        onClick={onIconClick}
      >
        <span
          className={clsx(
            'absolute right-0 top-1 transition-opacity duration-200',
            isOpen ? 'opacity-100' : 'opacity-0',
          )}
        >
          <Close color="currentColor" width="24px" height="24px" />
        </span>
        <span
          className={clsx(
            'absolute right-0 top-1 transition-opacity duration-200',
            isOpen ? 'opacity-0' : 'opacity-100',
          )}
        >
          {totalItems > 0 && (
            <span className="absolute -right-2 -top-2 flex h-4 w-4 items-center justify-center rounded-full bg-red-500 text-xs font-semibold text-black">
              {totalItems}
            </span>
          )}
          <Cart color="currentColor" width="24px" height="24px" />
        </span>
      </div>
    </div>
  );
};

export default CartHeader;
